export function installSettingsDateTimeFields({ mountEl = null, cleanup = [] } = {}) {
  void mountEl;
  return Array.isArray(cleanup) ? cleanup : [];
}
